<template>
    <GDialog
        v-model="modalStore.entityModal.show"
        max-width="500"
        border-radius="10"
        @update:model-value="hideModal"
    >
        <div v-if="!showLoader" class="entity-modal">
            <div class="container">
                <div class="modal-body">
                    <div class="modal-info">
                        <template v-if="taskData.info?.type === 'parcel'">
                            <div class="info-block">
                                <div class="block-header">
                                    <div class="info-title text-h3 text-bold">
                                        Деталі посилки
                                        <span class="text-h3 text-bold gradient-text">
                                            №{{ taskData.info?.company_number }}
                                        </span>
                                    </div>
                                    <div class="control-buttons">
                                        <div class="control-btn" @click="copyEntity">
                                            <img src="@/assets/images/copy-icon.svg" alt="" />
                                        </div>
                                        <div class="control-btn" @click="editEntity">
                                            <img src="@/assets/images/edit-round-icon.svg" alt="" />
                                        </div>
                                    </div>
                                </div>
                                <div v-if="taskData.info?.internal_id" class="info-row">
                                    <div class="text-h5 text-grey">Внутрішній ідентифікатор:</div>
                                    <div class="text-h4">{{ taskData.info?.internal_id }}</div>
                                </div>
                                <div v-if="taskData.info?.price" class="info-row">
                                    <div class="text-h5 text-grey">Ціна:</div>
                                    <div class="text-h4">{{ taskData.info?.price }}</div>
                                </div>
                                <div v-if="taskData.info?.seats_count" class="info-row">
                                    <div class="text-h5 text-grey">К-сть місць:</div>
                                    <div class="text-h4">{{ taskData.info.seats_count }}</div>
                                </div>
                                <div class="info-row">
                                    <div class="text-h5 text-grey">Приблизна вага:</div>
                                    <div class="text-h4">{{ taskData.info?.weight }}</div>
                                </div>
                                <div v-if="taskData.info?.dimensions" class="info-row">
                                    <div class="text-h5 text-grey">Габарити:</div>
                                    <div class="text-h4">{{ taskData.info?.dimensions }}</div>
                                </div>
                                <div class="info-row">
                                    <div class="text-h5 text-grey">Опис:</div>
                                    <div class="text-h4">{{ taskData.info?.description }}</div>
                                </div>
                            </div>

                            <div class="sender-info">
                                <div class="info-col">
                                    <div class="text-h5 text-grey">Відправник</div>
                                    <div class="text-h2 text-bold">
                                        {{ taskData.info?.sender?.full_name }}
                                    </div>
                                </div>
                                <div
                                    v-for="(phone, index) in taskData.info?.sender?.phones"
                                    :key="index"
                                    class="phone-item"
                                >
                                    <div class="phone-number-row">
                                        <span
                                            class="text-h4"
                                            :class="{
                                                'text-bold':
                                                    phone ===
                                                    taskData.info?.delivery_data?.sender_phone
                                            }"
                                            >{{ phone }}</span
                                        >
                                        <div class="copy-btn" @click="copyToClipboard(phone)">
                                            <img src="@/assets/images/copy-icon.svg" alt="Copy" />
                                        </div>
                                    </div>
                                    <div class="phone-actions">
                                        <CommunicationButtons
                                            :phone="phone"
                                            type="sender"
                                            :communications="communications"
                                            :active-dropdown="activeCommDropdown"
                                            :is-loading="isCommLoading"
                                            @toggle-dropdown="toggleCommDropdown"
                                            @close-dropdown="closeCommDropdown"
                                            @set-status="handleSetCommStatus"
                                            @copy="copyToClipboard"
                                        />
                                    </div>
                                </div>
                            </div>

                            <div class="info-block">
                                <div class="info-title text-h3 text-bold">Куди?</div>
                                <div class="info-row">
                                    <div class="text-h5 text-grey">Населений пункт:</div>
                                    <div class="text-h4">
                                        {{ taskData.info?.delivery_data?.to?.name }}
                                    </div>
                                </div>
                                <div class="info-row">
                                    <div class="text-h5 text-grey">Адреса:</div>
                                    <div class="text-h4">
                                        {{ taskData.info?.delivery_data?.to?.location_name }}
                                    </div>
                                </div>
                                <div class="info-row">
                                    <div class="text-h5 text-grey">Індекс:</div>
                                    <div class="text-h4">
                                        {{ taskData.info?.delivery_data?.to?.zip_code }}
                                    </div>
                                </div>
                            </div>

                            <div class="recipient-info">
                                <div class="info-col">
                                    <div class="text-h5 text-grey">Отримувач</div>
                                    <div class="text-h2 text-bold">
                                        {{ taskData.info?.recipient?.full_name }}
                                    </div>
                                </div>
                                <div
                                    v-for="(phone, index) in taskData.info?.recipient?.phones"
                                    :key="index"
                                    class="phone-item"
                                >
                                    <div class="phone-number-row">
                                        <span
                                            class="text-h4"
                                            :class="{
                                                'text-bold':
                                                    phone ===
                                                    taskData.info?.delivery_data?.recipient_phone
                                            }"
                                            >{{ phone }}</span
                                        >
                                        <div class="copy-btn" @click="copyToClipboard(phone)">
                                            <img src="@/assets/images/copy-icon.svg" alt="Copy" />
                                        </div>
                                    </div>
                                    <div class="phone-actions">
                                        <CommunicationButtons
                                            :phone="phone"
                                            type="recipient"
                                            :communications="communications"
                                            :active-dropdown="activeCommDropdown"
                                            :is-loading="isCommLoading"
                                            @toggle-dropdown="toggleCommDropdown"
                                            @close-dropdown="closeCommDropdown"
                                            @set-status="handleSetCommStatus"
                                            @copy="copyToClipboard"
                                        />
                                    </div>
                                </div>
                            </div>
                        </template>

                        <template v-if="taskData.info?.type === 'passenger'">
                            <div class="passenger-info">
                                <div class="block-header">
                                    <div class="info-col">
                                        <div class="text-h5 text-grey">Пасажир</div>
                                        <div class="text-h2 text-bold">
                                            {{ taskData.info?.passenger?.full_name }}
                                        </div>
                                    </div>
                                    <div class="control-buttons">
                                        <div class="control-btn" @click="copyEntity">
                                            <img src="@/assets/images/copy-icon.svg" alt="" />
                                        </div>
                                        <div class="control-btn" @click="editEntity">
                                            <img src="@/assets/images/edit-round-icon.svg" alt="" />
                                        </div>
                                    </div>
                                </div>
                                <div
                                    v-for="(phone, index) in taskData.info?.passenger?.phones"
                                    :key="index"
                                    class="phone-item"
                                >
                                    <div class="phone-number-row">
                                        <span
                                            class="text-h4"
                                            :class="{
                                                'text-bold':
                                                    phone ===
                                                    taskData.info?.selected_passenger_phone
                                            }"
                                            >{{ phone }}
                                        </span>
                                        <div class="copy-btn" @click="copyToClipboard(phone)">
                                            <img src="@/assets/images/copy-icon.svg" alt="Copy" />
                                        </div>
                                    </div>
                                    <div class="phone-actions">
                                        <CommunicationButtons
                                            :phone="phone"
                                            type="passenger"
                                            :communications="communications"
                                            :active-dropdown="activeCommDropdown"
                                            :is-loading="isCommLoading"
                                            @toggle-dropdown="toggleCommDropdown"
                                            @close-dropdown="closeCommDropdown"
                                            @set-status="handleSetCommStatus"
                                            @copy="copyToClipboard"
                                        />
                                    </div>
                                </div>
                            </div>

                            <div class="info-block">
                                <div v-if="taskData.info?.internal_id" class="info-row">
                                    <div class="text-h5 text-grey">Внутрішній ідентифікатор:</div>
                                    <div class="text-h4">{{ taskData.info?.internal_id }}</div>
                                </div>
                                <div v-if="taskData.info?.price" class="info-row">
                                    <div class="text-h5 text-grey">Ціна:</div>
                                    <div class="text-h4">{{ taskData.info?.price }}</div>
                                </div>
                                <div v-if="taskData.info?.passengers_count" class="info-row">
                                    <div class="text-h5 text-grey">К-сть пасажирів:</div>
                                    <div class="text-h4">{{ taskData.info.passengers_count }}</div>
                                </div>
                                <div class="info-row">
                                    <div class="text-h5 text-grey">Посадка:</div>
                                    <div class="text-h4">
                                        {{ taskData.from?.address }}
                                    </div>
                                </div>
                                <div class="info-row">
                                    <div class="text-h5 text-grey">Висадка:</div>
                                    <div class="text-h4">
                                        {{ taskData.to?.address }}
                                    </div>
                                </div>
                            </div>
                        </template>

                        <div class="payment-status">
                            <span class="text-h5 text-grey"> Статус оплати: </span>
                            <StatusComponent
                                v-if="taskData.info?.payment"
                                :status-options="paymentStatusOptions"
                                :current-status="taskData.info?.payment"
                                @update-status="updatePaymentStatus"
                            />
                        </div>

                        <TransactionsList
                            :entity_type="modalStore.entityModal?.entityType"
                            :entity_id="modalStore.entityModal?.entityId"
                        />

                        <div class="tasks-list">
                            <div class="tasks-list-title text-h3 text-bold">Список завдань</div>
                            <RouteTasksComponent
                                v-for="(routeInfo, index) in tasksList"
                                :key="index"
                                :route-info="routeInfo"
                                @task-status-change="updateTaskStatus"
                            />

                            <Transition name="fade">
                                <LoaderComponent v-if="showTasksLoader" />
                            </Transition>
                        </div>

                        <ImagesComponent
                            v-if="taskData.info?.images"
                            title-class="text-h3 text-bold"
                            form-data-key="images[]"
                            :block-data="taskData.info?.images"
                            block-title="Фото"
                            @load-image="loadImage"
                        />

                        <ImageDeleteModal
                            modal-title="Видалити фото?"
                            @submit-delete="submitImageDelete"
                        />

                        <!-- Comments block -->
                        <div class="comments-block">
                            <div class="row-header">
                                <div class="row-title text-h3 text-bold">Коментарі</div>

                                <div class="add-comment-btn">
                                    <img
                                        src="@/assets/images/add-transaction-icon.svg"
                                        alt=""
                                        @click="openCommentCreate"
                                    />
                                </div>
                            </div>

                            <div
                                v-if="
                                    Array.isArray(taskData.info?.comments) &&
                                    taskData.info.comments.length
                                "
                                class="comments-list"
                            >
                                <div
                                    v-for="item in taskData.info.comments"
                                    :key="item.id"
                                    class="comment-item"
                                >
                                    <div class="comment-content" @click="openCommentView(item)">
                                        <div class="comment-text text-h4">{{ item.text }}</div>
                                        <div class="comment-meta text-h6 text-grey">
                                            {{ item.updated_at }}
                                        </div>
                                    </div>

                                    <div class="comment-actions">
                                        <button
                                            v-if="item.can_edit"
                                            class="icon-btn"
                                            title="Редагувати"
                                            @click.stop="openCommentEdit(item)"
                                        >
                                            <img
                                                src="@/assets/images/edit-round-icon.svg"
                                                alt="edit"
                                            />
                                        </button>
                                        <button
                                            v-if="item.can_edit"
                                            class="icon-btn"
                                            title="Видалити"
                                            @click.stop="openCommentDeleteConfirmation(item)"
                                        >
                                            <img
                                                src="@/assets/images/delete-gradient-icon.svg"
                                                alt="delete"
                                            />
                                        </button>
                                    </div>
                                </div>
                            </div>
                            <div v-else class="text-h5 text-grey empty-text">
                                Коментарів поки немає
                            </div>

                            <CommentModal />
                            <ConfirmationModal
                                :show="showCommentDeleteConfirmation"
                                modal-title="Ви хочете видалити коментар?"
                                @submit-action="confirmDeleteComment"
                                @cancel-action="hideCommentDeleteConfirmation"
                            />
                        </div>

                        <div
                            v-if="
                                taskData.action_type === 'finish_trip' &&
                                taskData.info?.type === 'parcel'
                            "
                            class="extra-actions"
                        >
                            <div
                                class="extra-action-btn text-h5 text-center"
                                @click="showExtraActionConfirmation('return_action')"
                            >
                                Посилку не забрали
                            </div>
                            <div
                                class="extra-action-btn text-h5 text-center"
                                @click="showExtraActionConfirmation('retry_action')"
                            >
                                Отримають завтра
                            </div>
                        </div>
                    </div>
                </div>

                <div class="modal-buttons shadow-sm">
                    <div class="container">
                        <ButtonComponent
                            class="cancel-btn"
                            btn-style="grey"
                            text="Повернутись назад"
                            @click="hideModal"
                        />
                    </div>
                </div>
            </div>
        </div>
        <Transition name="fade">
            <LoaderComponent v-if="showLoader" />
        </Transition>
        <ConfirmationModal
            :show="extraActionConfirmation.show"
            :modal-title="extraActionConfirmation.title"
            :modal-description="extraActionConfirmation.description"
            submit-text="Підтвердити"
            @submit-action="confirmExtraAction"
            @cancel-action="cancelExtraAction"
        />
    </GDialog>
</template>

<script>
import { useActiveRouteStore, useModalStore } from '@/stores/index.js'
import { Clipboard } from '@capacitor/clipboard'
import vClickOutside from 'click-outside-vue3'
import fetchWrapper from '@/helpers/fetch-wrapper.js'
import ButtonComponent from '@/components/ButtonComponent.vue'
import StatusComponent from '@/components/StatusComponent.vue'
import ImageDeleteModal from '@/components/modals/ImageDeleteModal.vue'
import ImagesComponent from '@/components/ImagesComponent.vue'
import statusesMixin from '@/mixins/statusesMixin.js'
import LoaderComponent from '@/components/LoaderComponent.vue'
import TransactionsList from '@/components/TransactionsList.vue'
import RouteTasksComponent from '@/components/RouteTasksComponent.vue'
import CommentModal from '@/components/modals/CommentModal.vue'
import ConfirmationModal from '@/components/modals/ConfirmationModal.vue'
import CommunicationButtons from '@/components/CommunicationButtons.vue'

export default {
    name: 'EntityModal',
    components: {
        RouteTasksComponent,
        TransactionsList,
        ImagesComponent,
        ImageDeleteModal,
        StatusComponent,
        ButtonComponent,
        LoaderComponent,
        CommentModal,
        ConfirmationModal,
        CommunicationButtons
    },
    directives: {
        clickOutside: vClickOutside.directive
    },
    mixins: [statusesMixin],
    props: {
        fromScannerPage: {
            type: Boolean,
            default: false
        }
    },
    setup() {
        const modalStore = useModalStore()
        const activeRouteStore = useActiveRouteStore()

        return { modalStore, activeRouteStore }
    },
    data() {
        return {
            taskData: {},
            tasksList: [],
            showLoader: true,
            showTasksLoader: true,
            showCommentDeleteConfirmation: false,
            commentToDelete: null,
            extraActionConfirmation: {
                show: false,
                action: null,
                title: '',
                description: ''
            },
            communications: {},
            activeCommDropdown: {
                phone: null,
                type: null,
                comm: null
            },
            isCommLoading: false
        }
    },
    watch: {
        'modalStore.entityModal.show': {
            handler(newVal) {
                if (newVal) {
                    this.loadModalInfo()
                    this.loadTasksList()
                }
            },
            immediate: true
        }
    },
    methods: {
        copyEntity() {
            const type = this.taskData?.info?.type

            if (!type) return

            if (type === 'parcel') {
                const sender = this.taskData?.info?.sender || {}
                const recipient = this.taskData?.info?.recipient || {}
                const deliveryTo = this.taskData?.info?.delivery_data?.to || {}

                const points = this.activeRouteStore.routeData.points || []
                const hasUncompleted = points.some((p) => p.status?.value === 'Uncompleted')

                if (!hasUncompleted) {
                    this.$toast.error('Неможливо створити посилку — всі точки маршруту виконані')
                    return
                }

                const senderPhone =
                    this.taskData?.info?.delivery_data?.sender_phone ||
                    (sender.phones && sender.phones[0]) ||
                    ''
                const recipientPhone =
                    this.taskData?.info?.delivery_data?.recipient_phone ||
                    (recipient.phones && recipient.phones[0]) ||
                    ''

                const lastPointId = points.length ? points[points.length - 1].id : null

                const initialData = {
                    sender: {
                        name: sender.name || '',
                        surname: sender.surname || '',
                        phones: [
                            {
                                phone: (sender.phones && sender.phones[0]) || '',
                                communication_types: {
                                    viber: false,
                                    telegram: false,
                                    whatsapp: false
                                }
                            }
                        ],
                        selected_phone: senderPhone
                    },
                    recipient: {
                        name: recipient.name || '',
                        surname: recipient.surname || '',
                        phones: [
                            {
                                phone: (recipient.phones && recipient.phones[0]) || '',
                                communication_types: {
                                    viber: false,
                                    telegram: false,
                                    whatsapp: false
                                }
                            }
                        ],
                        selected_phone: recipientPhone,
                        address: {
                            id: deliveryTo.id || '',
                            name: deliveryTo.name || '',
                            warehouse_id: deliveryTo.warehouse_id || '',
                            location_name: deliveryTo.location_name || '',
                            zip_code: deliveryTo.zip_code || '',
                            address_type: deliveryTo.address_type || 'address',
                            has_nova_post: deliveryTo.address_type === 'new-post'
                        }
                    },
                    parcel: {
                        weight: this.taskData?.info?.weight ?? null,
                        price: this.taskData?.info?.price ?? null,
                        items_count: this.taskData?.info?.seats_count ?? 1,
                        description: this.taskData?.info?.description || ''
                    },

                    arrival: {
                        route_point_id: lastPointId,
                        action_type: 'finish_trip'
                    },
                    payment_status: 'Not paid',
                    comment: '',
                    images: []
                }

                this.modalStore.addParcelModal.initialData = initialData
                this.modalStore.addParcelModal.mode = 'create'
                this.modalStore.addParcelModal.show = true
                this.hideModal()

                return
            }

            if (type === 'passenger') {
                const passenger = this.taskData?.info?.passenger || {}

                const passengerPhone =
                    this.taskData?.info?.selected_passenger_phone ||
                    (passenger.phones && passenger.phones[0]) ||
                    ''

                const initialData = {
                    passenger: {
                        name: passenger.name || '',
                        surname: passenger.surname || '',
                        selected_phone: passengerPhone,
                        phones: [
                            {
                                phone: passengerPhone,
                                communication_types: {
                                    viber: false,
                                    telegram: false,
                                    whatsapp: false
                                }
                            }
                        ]
                    }
                }

                const points = this.activeRouteStore.routeData.points || []
                const hasUncompleted = points.some((p) => p.status?.value === 'Uncompleted')

                if (!hasUncompleted) {
                    this.$toast.error('Неможливо створити пасажира — всі точки маршруту виконані')
                    return
                }

                this.modalStore.addPassengerModal.initialData = initialData
                this.modalStore.addPassengerModal.mode = 'create'
                this.modalStore.addPassengerModal.show = true
                this.hideModal()
            }
        },

        editEntity() {
            const type = this.taskData?.info?.type

            if (!type) return

            const lastTaskPoint = this.getLastActiveTask(this.tasksList)

            if (type === 'parcel') {
                const sender = this.taskData?.info?.sender || {}
                const recipient = this.taskData?.info?.recipient || {}
                const deliveryTo = this.taskData?.info?.delivery_data?.to || {}
                const payment = this.taskData?.info?.payment?.value || 'Not paid'

                const senderPhone =
                    this.taskData?.info?.delivery_data?.sender_phone ||
                    (sender.phones && sender.phones[0]) ||
                    ''
                const recipientPhone =
                    this.taskData?.info?.delivery_data?.recipient_phone ||
                    (recipient.phones && recipient.phones[0]) ||
                    ''

                const initialData = {
                    sender: {
                        name: sender.name || '',
                        surname: sender.surname || '',
                        phones: [
                            {
                                phone: senderPhone,
                                communication_types: {
                                    viber: false,
                                    telegram: false,
                                    whatsapp: false
                                }
                            }
                        ],
                        selected_phone: senderPhone
                    },
                    recipient: {
                        name: recipient.name || '',
                        surname: recipient.surname || '',
                        phones: [
                            {
                                phone: recipientPhone,
                                communication_types: {
                                    viber: false,
                                    telegram: false,
                                    whatsapp: false
                                }
                            }
                        ],
                        selected_phone: recipientPhone,
                        address: {
                            id: deliveryTo.id || '',
                            name: deliveryTo.name || '',
                            warehouse_id: deliveryTo.warehouse_id || '',
                            location_name: deliveryTo.location_name || '',
                            zip_code: deliveryTo.zip_code || '',
                            address_type: deliveryTo.address_type || 'address',
                            has_nova_post: deliveryTo.address_type === 'new-post'
                        }
                    },
                    parcel: {
                        weight: this.taskData?.info?.weight ?? null,
                        price: this.taskData?.info?.price ?? null,
                        items_count: this.taskData?.info?.seats_count ?? 1,
                        description: this.taskData?.info?.description || ''
                    },
                    arrival: {
                        route_point_id: lastTaskPoint.route_point_id || '',
                        action_type: lastTaskPoint.action_type || ''
                    },
                    payment_status: payment,
                    images: []
                }

                this.modalStore.addParcelModal.initialData = initialData
                this.modalStore.addParcelModal.entityId = this.taskData?.info?.id
                this.modalStore.addParcelModal.mode = 'edit'
                this.modalStore.addParcelModal.show = true
                this.hideModal()

                return
            }

            if (type === 'passenger') {
                const passenger = this.taskData?.info?.passenger || {}
                const payment = this.taskData?.info?.payment?.value || 'Not paid'
                const passengerPhone =
                    this.taskData?.info?.selected_passenger_phone ||
                    (passenger.phones && passenger.phones[0]) ||
                    ''

                const initialData = {
                    price: this.taskData?.info?.price ?? null,
                    passenger: {
                        name: passenger.name || '',
                        surname: passenger.surname || '',
                        selected_phone: passengerPhone,
                        phones: [
                            {
                                phone: passengerPhone,
                                communication_types: {
                                    viber: false,
                                    telegram: false,
                                    whatsapp: false
                                }
                            }
                        ]
                    },
                    arrival: {
                        route_point_id: lastTaskPoint.route_point_id || '',
                        action_type: lastTaskPoint.action_type || ''
                    },
                    payment_status: payment,
                    images: []
                }

                this.modalStore.addPassengerModal.initialData = initialData
                this.modalStore.addPassengerModal.entityId = this.taskData?.info?.id
                this.modalStore.addPassengerModal.mode = 'edit'
                this.modalStore.addPassengerModal.show = true
                this.hideModal()
            }
        },

        getLastActiveTask(tasksList) {
            const activeRoute = tasksList.find((item) => item.route.active)

            if (!activeRoute || !activeRoute.tasks.length) return null

            const lastTask = activeRoute.tasks[activeRoute.tasks.length - 1]

            return {
                route_point_id: lastTask.action_route_point?.id || null,
                action_type: lastTask.action_type || null
            }
        },

        openCommentCreate() {
            this.modalStore.commentModal.mode = 'create'
            this.modalStore.commentModal.show = true
            this.modalStore.commentModal.text = ''
            this.modalStore.commentModal.entityId = this.taskData?.info?.id
            this.modalStore.commentModal.entityType = this.taskData?.info?.type
            this.modalStore.commentModal.can_edit = true
            this.modalStore.commentModal.onCreated = (newItem) => {
                if (!Array.isArray(this.taskData.info.comments)) {
                    this.$set
                        ? this.$set(this.taskData.info, 'comments', [])
                        : (this.taskData.info.comments = [])
                }
                this.taskData.info.comments.push(newItem)
            }
        },

        openCommentView(item) {
            this.modalStore.commentModal.mode = 'view'
            this.modalStore.commentModal.show = true
            this.modalStore.commentModal.text = item.text
            this.modalStore.commentModal.commentId = item.id
            this.modalStore.commentModal.can_edit = !!item.can_edit
            this.modalStore.commentModal.onEdited = (fullArray) => {
                // backend returns full array on edit
                this.taskData.info.comments = fullArray
            }
        },

        openCommentEdit(item) {
            this.modalStore.commentModal.mode = 'edit'
            this.modalStore.commentModal.show = true
            this.modalStore.commentModal.text = item.text
            this.modalStore.commentModal.commentId = item.id
            this.modalStore.commentModal.can_edit = !!item.can_edit
            this.modalStore.commentModal.onEdited = (fullArray) => {
                this.taskData.info.comments = fullArray
            }
        },

        openCommentDeleteConfirmation(item) {
            if (!item?.id) return
            this.commentToDelete = item
            this.showCommentDeleteConfirmation = true
        },

        hideCommentDeleteConfirmation() {
            this.showCommentDeleteConfirmation = false
            this.commentToDelete = null
        },

        confirmDeleteComment() {
            if (!this.commentToDelete?.id) return
            const id = this.commentToDelete.id

            fetchWrapper.delete(`comments/delete/${id}`, {}).then(() => {
                if (Array.isArray(this.taskData.info?.comments)) {
                    this.taskData.info.comments = this.taskData.info.comments.filter(
                        (c) => c.id !== id
                    )
                }
                this.$toast.success('Коментар видалено')
                this.hideCommentDeleteConfirmation()
            })
        },

        loadModalInfo() {
            this.showLoader = true

            fetchWrapper
                .post(`/route-point-entities/load-page/${this.modalStore.entityModal.entityId}`, {
                    type: this.modalStore.entityModal.entityType
                })
                .then((response) => {
                    this.taskData = response
                    this.communications = response.communications || {}
                })
                .finally(() => {
                    this.showLoader = false
                })
        },

        loadTasksList() {
            this.showTasksLoader = true
            const entityType = this.modalStore.entityModal.entityType
            const entityId = this.modalStore.entityModal.entityId

            fetchWrapper
                .post(`/route-point-entities/load-tasks/${entityId}`, {
                    type: entityType
                })
                .then((response) => {
                    this.tasksList = response
                })
                .finally(() => {
                    this.showTasksLoader = false
                })
        },

        updatePaymentStatus(status) {
            fetchWrapper
                .patch('/route-point-entities/update-payment-status', {
                    id: this.taskData.info.id,
                    type: this.taskData.info.type,
                    status
                })
                .then((response) => {
                    this.taskData.info.payment = response
                    this.activeRouteStore.updateEntityPaymentInRouteData(
                        this.taskData.info.id,
                        this.taskData.info.type,
                        response
                    )
                    this.$toast.success('Статус оплати змінено')
                })
        },

        updateTaskStatus(statusData) {
            this.tasksList.forEach((item) => {
                item.tasks.forEach((task) => {
                    if (task.action_id === statusData.actionId) {
                        task.action_status = statusData.status
                    }
                })
            })
        },

        showExtraActionConfirmation(action) {
            const actionTexts = {
                return_action: {
                    title: 'Посилку не забрали?',
                    description: 'Підтвердіть, що посилку не забрали'
                },
                retry_action: {
                    title: 'Отримають завтра?',
                    description: 'Підтвердіть, що посилку отримають завтра'
                }
            }

            this.extraActionConfirmation.show = true
            this.extraActionConfirmation.action = action
            this.extraActionConfirmation.title = actionTexts[action].title
            this.extraActionConfirmation.description = actionTexts[action].description
        },

        confirmExtraAction() {
            const action = this.extraActionConfirmation.action

            fetchWrapper
                .patch(`/route-point-tasks/set-extra-action/${this.taskData.action_id}`, {
                    action_type: action
                })
                .then((response) => {
                    this.taskData.action_status = response.data
                    this.taskData.action_type = action
                    this.loadTasksList()
                    this.activeRouteStore.updateStatusesInRouteData(
                        this.taskData.action_id,
                        response,
                        action
                    )
                    this.$toast.success('Статус завдання змінено')
                })
                .finally(() => {
                    this.cancelExtraAction()
                })
        },

        cancelExtraAction() {
            this.extraActionConfirmation.show = false
            this.extraActionConfirmation.action = null
            this.extraActionConfirmation.title = ''
            this.extraActionConfirmation.description = ''
        },

        async loadImage(formData) {
            formData.append('id', this.taskData.info.id)
            formData.append('type', this.taskData.info.type)

            fetchWrapper
                .post('/route-point-entities/create-images', formData, {
                    headers: {
                        'Content-Type': 'multipart/form-data'
                    }
                })
                .then((response) => {
                    this.taskData.info.images = response
                    this.$toast.success('Фото додано')
                })
        },

        submitImageDelete(id) {
            fetchWrapper
                .delete(
                    `/route-point-entities/delete-image/${this.modalStore.imageConfirmationModal.itemIdForDelete}`,
                    {}
                )
                .then(() => {
                    this.taskData.info.images = this.taskData.info.images.filter((item) => {
                        return item.id !== id
                    })
                    this.$toast.success('Фото видалено')
                })
        },

        async copyToClipboard(textToCopy) {
            await Clipboard.write({
                string: textToCopy
            })
            this.$toast.success('Скопійовано')
        },

        hideModal() {
            this.modalStore.entityModal.show = false
            this.modalStore.entityModal.entityType = null
            this.modalStore.entityModal.entityId = null
            this.taskData = {}
            this.communications = {}
            this.activeCommDropdown = { phone: null, type: null, comm: null }

            if (this.fromScannerPage) {
                this.$router.push({ name: 'homePage' })
            }
        },

        toggleCommDropdown({ phone, type, comm, event }) {
            if (event) event.stopPropagation()

            if (
                this.activeCommDropdown.phone === phone &&
                this.activeCommDropdown.type === type &&
                this.activeCommDropdown.comm === comm
            ) {
                this.closeCommDropdown()
                return
            }

            this.activeCommDropdown = { phone, type, comm }

            this.$nextTick(() => {
                const handler = () => {
                    this.closeCommDropdown()
                    document.removeEventListener('click', handler)
                }
                document.addEventListener('click', handler)
            })
        },

        closeCommDropdown() {
            this.activeCommDropdown = { phone: null, type: null, comm: null }
        },

        handleSetCommStatus({ phone, type, comm, status }) {
            this.setCommStatus(phone, type, comm, status)
        },

        setCommStatus(phone, type, comm, status) {
            this.isCommLoading = true
            const entityId = this.modalStore.entityModal.entityId
            const entityType = this.modalStore.entityModal.entityType

            const url =
                entityType === 'parcel'
                    ? `/parcels/save-communication/${entityId}`
                    : `/bookings/save-communication/${entityId}`

            fetchWrapper
                .post(url, {
                    type,
                    phone,
                    communication: comm,
                    status
                })
                .then((response) => {
                    this.communications = response.communications || {}
                    this.activeRouteStore.updateEntityCommunicationsInRouteData(
                        entityId,
                        entityType,
                        response.communications
                    )
                    this.closeCommDropdown()
                    this.$toast.success('Статус комунікації оновлено')
                })
                .finally(() => {
                    this.isCommLoading = false
                })
        },

        getCommStatus(phone, type, comm) {
            return this.communications?.[type]?.[phone]?.[comm]
        }
    }
}
</script>

<style scoped lang="scss">
.sender-info,
.recipient-info,
.passenger-info {
    display: flex;
    flex-direction: column;
    border-bottom: 1px solid $grey-light;
    padding: 1rem 0;

    .phone-item {
        display: flex;
        flex-direction: column;
        height: fit-content;
        color: $black;

        .phone-number-row {
            display: flex;
            align-items: center;
            margin-bottom: 0.625rem;

            .copy-btn {
                display: flex;
                align-items: center;
                margin-left: 0.625rem;
                cursor: pointer;
            }
        }
    }
}

.block-header {
    display: flex;
    align-items: flex-start;

    .control-buttons {
        display: flex;
        margin-left: auto;

        .control-btn {
            margin-left: 0.625rem;
        }
    }
}

.passenger-info {
    padding-top: 0;
}

.info-block {
    padding: 1rem 0;
    border-bottom: 1px solid $grey-light;

    &:first-of-type {
        padding-top: 0;
    }

    .info-title {
        margin-bottom: 0.7rem;
    }

    .info-row {
        display: flex;
        margin-bottom: 0.7rem;

        div:first-of-type {
            margin-right: 0.5rem;
        }

        &:last-of-type {
            margin-bottom: 0;
        }
    }
}

.payment-status {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 1rem 0;
    border-bottom: 1px solid $grey-light;
}

.tasks-list {
    position: relative;
    padding-top: 1.25rem;
    border-bottom: 1px solid $grey-light;

    .tasks-list-title {
        margin-bottom: 0.75rem;
    }
}

.images-block {
    display: flex;
    flex-direction: column;
    border-bottom: 1px solid $grey-light;
    padding: 1rem 0;

    .row-header {
        display: flex;
        align-items: center;
        justify-content: space-between;

        .row-title {
            margin-right: 1.5rem;
        }

        .file-input {
            display: none;
        }

        label {
            height: fit-content;
        }
    }

    .row-body {
        display: flex;
        flex-wrap: wrap;
        justify-content: space-between;

        .photo-item {
            position: relative;
            width: calc(50% - 0.25rem);
            margin-bottom: 0.5rem;
            border-radius: 0.5rem;
            overflow: hidden;
            padding-top: 28%;

            &:nth-child(1),
            &:nth-child(2) {
                margin-top: 1.25rem;
            }

            .photo-image {
                position: absolute;
                top: 0;
                left: 0;
                width: 100%;
                height: 100%;
                object-fit: cover;
            }
        }

        .delete-icon {
            position: absolute;
            top: 0.5rem;
            right: 0.5rem;
            z-index: 5;
        }
    }
}

.comments-block {
    display: flex;
    flex-direction: column;
    border-bottom: 1px solid $grey-light;
    padding: 1rem 0;

    .row-header {
        display: flex;
        align-items: center;
        justify-content: space-between;
    }

    .comments-list {
        margin-top: 1rem;

        .comment-item {
            display: flex;
            align-items: flex-start;
            justify-content: space-between;
            padding: 0.75rem 0;
            border-bottom: 1px solid $grey-light;

            &:last-child {
                border-bottom: none;
            }

            .comment-content {
                flex: 1;
                padding-right: 0.5rem;
            }

            .comment-text {
                white-space: pre-wrap;
            }

            .comment-meta {
                margin-top: 0.25rem;
            }

            .comment-actions {
                display: flex;

                .icon-btn {
                    background: transparent;
                    border: none;
                    padding: 0.25rem;
                    margin-left: 0.25rem;
                }
            }
        }
    }

    .empty-text {
        margin-top: 1rem;
    }
}

.extra-actions {
    display: flex;
    justify-content: space-between;
    margin-top: 1.25rem;

    .extra-action-btn {
        display: flex;
        align-items: center;
        justify-content: center;
        width: calc(50% - 0.5rem);
        border: 1px solid $grey;
        border-radius: 0.375rem;
        padding: 0.5rem 1rem;
    }
}

.modal-buttons .button-component {
    width: 100% !important;
}
</style>
